import { AuthorizationRoleInheritanceModel } from "./AuthorizationRoleInheritanceModel";

export class RoleGroupModel{
    id: string;
    authorizationRoleId: string;
    authorizationRoleInheritances: AuthorizationRoleInheritanceModel[];
    roleType: string;
}